import { useAsyncValue, useRequestConnectedToAsyncValue } from '../..';
import { get } from '../../../redux/api';
import type { MinimalBranch } from '../../../shared/branches/types';
import { nuc } from '../../../utils';

const fetchBranches = (locator: string) => {
  return get<MinimalBranch[]>(`/api/projects/${nuc(locator)}/branches`);
};

const useFetchBranches = () => {
  const asyncValue = useAsyncValue<MinimalBranch[]>(null);
  const onFetchBranches = useRequestConnectedToAsyncValue(
    fetchBranches,
    asyncValue,
  ) as unknown as typeof fetchBranches;

  return {
    onFetchBranches,
    areBranchesLoading: asyncValue.isLoading,
    branches: asyncValue.value ?? [],
  };
};

export default useFetchBranches;
